import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import PerksUserDetail from '../../../PerksHub/PerksUserDetail';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchPerksUserDetail } from './companyPerksApi';

/**
 * Company Perks → one employee's/member's perks profile. Reuses the shared
 * detail page with the company-scoped fetcher (the backend 404s any user who
 * doesn't belong to this company).
 */
const CPerksUserDetail = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>User Perks Profile | Shoorah</title>
      </Helmet>
      <PerksUserDetail
        fetcher={fetchPerksUserDetail}
        backPath={`/${slug}/perks/users`}
        backLabel={isB2BFansMode ? 'Back to Members' : 'Back to Employees'}
      />
    </div>
  );
};

export default CPerksUserDetail;
